import PropTypes from 'prop-types'
import React from 'react'

import ThirdPartyTracking from '@thebeansgroup/third_party_tracking'

import {
  navigateToLogInPage,
  getEmailFromUrlQuery
} from '@src/authorisation/children/router/helpers'
import { checkForPageErrors } from '@src/authorisation/helpers'
import { THIRD_PARTY_TRACKING_CONFIG } from '@src/constants'
import Snowplow from '@src/snowplow'

import { ResetPasswordScreen, EmailSentScreen } from './children'
import { canDisplayEmailSentScreen } from './helpers'

class ResetPassword extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      emailSent: false
    }
    this.bindHandlers()
  }

  bindHandlers() {
    this.onEmailChange = this.onEmailChange.bind(this)
    this.onRequestError = this.onRequestError.bind(this)
    this.onLogInClick = this.onLogInClick.bind(this)
    this.onResetPassword = this.onResetPassword.bind(this)
  }

  componentDidMount() {
    Snowplow.trackPageView()
    ThirdPartyTracking.init(
      getEmailFromUrlQuery(this.props),
      THIRD_PARTY_TRACKING_CONFIG
    )
    ThirdPartyTracking.pageView()
    checkForPageErrors(this.props.data)
  }

  onEmailChange(value) {
    this.setState({ email: value })
  }

  onRequestError(data) {
    this.props.data.errorHandler(data)
  }

  onLogInClick() {
    navigateToLogInPage(this.props)
  }

  onResetPassword() {
    this.setState({ emailSent: true })
  }

  renderEmailSentScreen() {
    ThirdPartyTracking.sessionReplay()
    return (
      <EmailSentScreen
        email={this.state.email}
        logInClickHandler={this.onLogInClick}
      />
    )
  }

  renderResetPasswordScreen() {
    return (
      <ResetPasswordScreen
        token={this.props.data.token}
        email={this.state.email}
        requestErrorHandler={this.onRequestError}
        resetPasswordHandler={this.onResetPassword}
        emailValueChangeHandler={this.onEmailChange}
        logInClickHandler={this.onLogInClick}
        country={this.props.params?.country}
      />
    )
  }

  renderContent() {
    if (canDisplayEmailSentScreen(this.state)) {
      return this.renderEmailSentScreen()
    }
    return this.renderResetPasswordScreen()
  }

  render() {
    return <>{this.renderContent()}</>
  }
}

ResetPassword.propTypes = {
  data: PropTypes.shape({
    user: PropTypes.object.isRequired,
    error: PropTypes.string,
    token: PropTypes.string.isRequired,
    errorHandler: PropTypes.func.isRequired
  })
}

export default ResetPassword
